/**
 * Single source of truth for all TanStack Query cache keys in the ControlCenter domain.
 * Import from here in both hooks (readers) and mutations (writers) so a reader
 * and its writers share the exact same key and cannot drift independently.
 */
export const QUERY_KEYS = {
  featureFlags: ['control-center-feature-flags'],
  alerts: ['control-center-alerts'],
  applications: ['control-center-applications'],
  clients: ['control-center-admin-clients'],
} as const
